import { AppliedCreditNote, CurrentPayment, Invoice } from 'Invoices/types'

export const currentCreditNotes = (invoice: Invoice): AppliedCreditNote[] => {
  return (invoice.currentlyApplied?.creditNotes ?? []).map(creditNote => ({
    id: creditNote.creditNoteId,
    creditNoteNumber: creditNote.creditNoteNumber ?? undefined,
    netTotal: creditNote.netTotal,
    totalTax: creditNote.totalTax,
    grossTotal: creditNote.grossTotal,
    appliedAmount: creditNote.amount,
    lineItems: creditNote.lineItems
  }))
}

export const currentPayments = (invoice: Invoice): CurrentPayment[] => {
  return invoice.currentlyApplied?.payments ?? []
}
